export default {
  accounts: state => state.accounts,
  selectedAccount: state => state.activeAccount,
  usergroups: state => state.usergroups,
  selectedUsergroup: state => state.activeUsergroup
};
